const adminRoute = '/admin';
const signInRoute = '/sign-in';
const signUpRoute = '/sign-up';
const docsAppRoute = '/docs-app';
const startUpRoute = '/start-up';

const profileRoute = '/profile';
const developmentRoute = '/development';
const companiesRoute = '/companies';
const companyRoute = '/company';

const permissionsManagementRoute = '/management-page';
const carriersRoute = '/carriers-page';

export const routes = {
  adminRoute,
  signInRoute,
  signUpRoute,
  docsAppRoute,
  startUpRoute,
  profileRoute,
  developmentRoute,
  companiesRoute,
  companyRoute,
  permissionsManagementRoute,
  carriersRoute,
};
